/** Textes « cautions » — le français fait foi. */
export const cautions = {
  formes: { especes: 'Espèces', cheque: 'Chèque', traite: 'Traite', carte: 'Carte' } as Record<string, string>,
  traitee: 'Caution traitee — la decharge de restitution est prete a imprimer.',
  erreur: 'Erreur',
  titre: 'Cautions et décharges',
  sousTitre: 'Chaque caution génère sa décharge, numérotée et signée — à la remise comme à la restitution',
  filtres: { detenue: 'Détenues', restituee: 'Restituées', retenue_partielle: 'Retenue partielle', saisie: 'Saisies', toutes: 'Toutes' },
  detenusTitre: (m: string) => `${m} détenus pour le compte de vos clients`,
  detenusTexte: 'Cet argent est en caisse mais ne vous appartient pas : il est déjà retiré de votre trésorerie disponible.',
  vide: 'Aucune caution',
  colDecharge: 'Décharge', colClient: 'Client', colContrat: 'Contrat', colForme: 'Forme',
  colMontant: 'Montant', colRetenu: 'Retenu', colStatut: 'Statut',
  decharge: 'Décharge',
  restitution: 'Restitution',
  restituer: 'Restituer',
  reserveHichem: "La restitution d'une caution est une opération financière : elle est réservée au gérant · finances.",
  restituerTitre: (n: string) => `Restituer la caution ${n}`,
  detenus: (m: string) => `${m} detenus`,
  contrat: (n: string | undefined) => `contrat ${n}`,
  montantRetenu: 'Montant retenu',
  montantRetenuAide: 'Laissez 0 pour restituer la totalite.',
  motif: 'Motif de la retenue (obligatoire)',
  motifPlaceholder: 'Dommage constaté au retour, carburant manquant…',
  aRestituer: 'A restituer',
  sigClient: 'Signature du client',
  sigDirecteur: 'Signature du directeur',
  annuler: 'Annuler',
  restituerEditer: 'Restituer et éditer la décharge',
};
